import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

const getUserPhoto = (photoType: string, userId: number) => {
  return getRequest<string>(`/users/photo?photo_type=${photoType}&user_id=${userId}`)
}

export const useUserPhoto = (photoType: string, userId: number) => {
  return useSuspenseQuery({
    ...queries.users.detailById(userId)._ctx.photos(photoType),
    queryFn: () => getUserPhoto(photoType, userId),
    staleTime: Infinity,
  })
}
